import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00b02b7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Museum view-default" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Museum__gradient-bottom" }, null, -1))
const _hoisted_3 = { class: "Museum__Inner view-default__inner" }
const _hoisted_4 = { class: "ScrollHint" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ScrollHint__Bar-1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ScrollHint__Bar-2" }, null, -1))
const _hoisted_7 = { class: "ScrollHint__Label small-caps" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIBtnDive = _resolveComponent("UIBtnDive")!
  const _component_ArtworkCaption = _resolveComponent("ArtworkCaption")!
  const _component_GetTicket = _resolveComponent("GetTicket")!
  const _component_CustomCursor = _resolveComponent("CustomCursor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_Transition, {
        onEnter: _ctx.artworkEnterAnim,
        onLeave: _ctx.artworkLeaveAnim
      }, {
        default: _withCtx(() => [
          (_ctx.showDiveBtn)
            ? (_openBlock(), _createBlock(_component_UIBtnDive, {
                key: 0,
                type: "button",
                onClick: _ctx.onGoPainting
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onEnter", "onLeave"]),
      _createVNode(_Transition, {
        onEnter: _ctx.scrollEnterAnim,
        onLeave: _ctx.scrollLeaveAnim
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('museum.scroll_hint')), 1)
          ], 512), [
            [_vShow, _ctx.showScrollHint]
          ])
        ]),
        _: 1
      }, 8, ["onEnter", "onLeave"]),
      _createVNode(_Transition, {
        onEnter: _ctx.artworkEnterAnim,
        onLeave: _ctx.artworkLeaveAnim
      }, {
        default: _withCtx(() => [
          (_ctx.nearbyArtworkId || _ctx.forceArtworkDescription)
            ? (_openBlock(), _createBlock(_component_ArtworkCaption, {
                key: 0,
                artworkId: _ctx.nearbyArtworkId || _ctx.selectedArtworkId,
                open: _ctx.forceArtworkDescription
              }, null, 8, ["artworkId", "open"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onEnter", "onLeave"]),
      _createVNode(_Transition, {
        onEnter: _ctx.artworkEnterAnim,
        onLeave: _ctx.artworkLeaveAnim
      }, {
        default: _withCtx(() => [
          (_ctx.showTickets)
            ? (_openBlock(), _createBlock(_component_GetTicket, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onEnter", "onLeave"]),
      _withDirectives(_createVNode(_component_CustomCursor, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('museum.main_painting_cursor')), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, _ctx.showMainPaintingCursor]
      ])
    ])
  ]))
}